export default __webpack_public_path__ + "static/media/roy-kombucha-fermented-tea.255b0eae.png";